export default __webpack_public_path__ + "static/media/step_img_9.49460d96.png";